module.exports = __webpack_public_path__ + "static/media/logo-hulu.e8f4d136.png";